<template>
    <div class="active">
        <p class="title">全国活动列表</p>
        <el-select v-model="provinceId" size="large" class="selectBox" filterable placeholder="请选择省" @change="handlePageChange(1)" clearable @clear="clearVal('provinceId')">
            <el-option v-for="item in cityData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <div class="box">
            <el-table :data="activaData" style="width: 100%">
                <el-table-column prop="id" label="活动ID" width="100" align="center"></el-table-column>
                <el-table-column prop="title" label="活动名称" align="center"></el-table-column>
                <el-table-column label="类型" align="center">
                    <template slot-scope="scope">
                        <span>{{activityTypeList.find(v => v.id == scope.row.typeId).label}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="主办方" align="right" width="150">
                    <template slot-scope="scope">
                    <div>{{scope.row.sponsorName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="dancesStr" label="舞种" align="center"></el-table-column>
                <el-table-column prop="fullAddress" label="地址" align="center"></el-table-column>
                <el-table-column label="活动时间" align="center">
                    <template slot-scope="scope">
                        <div>{{ scope.row.startTime | formatDate }}</div>
                        <div>{{ scope.row.endTime | formatDate }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="statusLabel" label="状态" align="center"></el-table-column>
            </el-table>
            <el-pagination class="pagination" background hide-on-single-page layout="prev, pager, next" :total="total" :current-page="pageData.pageNumber" :page-size="pageData.pageSize" @current-change="handlePageChange" />
        </div>
    </div>
</template>

<script>
import { cityData } from '../../city.js'
import * as moment from 'moment';
import bigData from '@/services/bigData'
import DictService from '@/services/system/dict';
import * as _ from 'lodash';
export default {
    data() {
        return {
            provinceId: '',
            pageData: {
                pageSize: 10,
                pageNumber: 1
            },
            activaData: [],
            cityData: cityData,
            total: 0,
            activityTypeList: []
        }
    },
    async created() {
        await this.initDictData()
        this.getList()
    },
    methods: {
        async getList() {
            const { code, message, result: { data, total } } = await bigData.nationData({ provinceId: this.provinceId, ...this.pageData });
            if (Object.is(code, 0)) {
                this.activaData = data.map((item) => {
                const { key: statusValue, value: statusLabel } = this.activityStatus(item);
                return {
                    ...item,
                    typeName: item.typeDict ? item.typeDict.label : '',
                    statusLabel,
                    statusValue,
                    danceName: item.danceList ? item.danceList.map((item) => item.name).join(',') : '',
                }
                });
                this.total = total;
                this.loadData = false;
            } else {
                console.error('获取活动列表失败', message);
            }
        },
        activityStatus (data) {
            const currentDate = moment(new Date());
            if (moment(data.startTime) <= currentDate && moment(data.endTime) >= currentDate) {
                return {
                key: 1,
                value: '进行中'
                }
            } else if (moment(data.startTime) > currentDate) {
                return {
                key: 2,
                value: '未开始'
                }
            } else if (moment(data.endTime) < currentDate) {
                return {
                key: 3,
                value: '已结束'
                }
            } else {
                return {
                key: '',
                value: '',
                }
            }
        },
        // 获取类型、级别配置信息
        async initDictData () {
            const { code, message, result } = await DictService.dictByTypeApi({ category: ['activity_type', 'activity_level'] });
            if (Object.is(code, 0)) {
                // 使用分组
                const { activity_type } = _.groupBy(result, 'category');
                this.activityTypeList = activity_type;
            } else {
                console.log(message);
            }
        },
        handlePageChange(val) {
            this.pageData.pageNumber = val;
            this.getList()
        }
    }
}
</script>

<style lang="scss" scoped>
.title{
    margin-top: 24px;
    color: #fff;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 13px;
}
.selectBox{
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;
}
::v-deep .el-input__inner{
    background-color: #151522;
    border: none;
    color: #A1A1CC
}
.el-scrollbar{
    background-color: #151522;
    color: #fff;
}
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #151522;
    color: #fff;
}
.box{
    box-sizing: border-box;
    background-color: #292941;
    border-radius: 12px;
    padding: 16px;
}
::v-deep thead{
    color: #A1A1CC
}
::v-deep .el-table{
    background-color: transparent
}
::v-deep .el-table tr{
    background-color: transparent !important;
    border: none !important;
    
}
::v-deep .el-table th{
    background-color: transparent !important;
    border: none !important;
}
::v-deep .el-table td{
    border: none !important;
    color: #fff;
    border-bottom: 1px solid #2F2F48 !important
}
::v-deep .el-table tbody tr:hover>td {
    background-color: #222236 !important
}
.el-table::before{
    height: 0;
}
.el-table--border::after{
    width: 0;
}
.el-table--border, .el-table--group{
    border: none !important
}

::v-deep .el-input__inner::placeholder {
  color: #A1A1CC;
}
/* 谷歌 */
::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #A1A1CC;
}
/* 火狐 */
::v-deep .el-input__inner:-moz-placeholder {
  color: #A1A1CC;
}
/*ie*/
::v-deep .el-input__inner:-ms-input-placeholder {
  color: #A1A1CC;
}
::v-deep .pagination{
    .number, .more{
        background-color: #24243A !important;
        border-radius: 6px !important;
        color: #fff !important;
        width: 32px;
        height: 32px;
        line-height: 32px;
    }
    .btn-prev, .btn-next{
        background-color: #4d4d7d;
        width: 32px;
        height: 32px;
        line-height: 32px;
        color: #fff;
        border-radius: 6px;
    }
    .number.active{
        background: linear-gradient(132deg, #5455FF 0%, #5484FF 100%);
    }
}
.pagination {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 30px 0;
}
</style>
